/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { billingReportRefreshKeys, checkInComplianceRefreshKeys } from "./sharedRefreshKeys";

const baseConfiguredDiscountKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.configured_discounts),
  getBaseQueryKey(Query_Keys.discount_report_summary),
  getBaseQueryKey(Query_Keys.discount_report_breakdown),
  getBaseQueryKey(Query_Keys.configured_discounts_dropdown),
  getBaseQueryKey(Query_Keys.discount_reports),
  getBaseQueryKey(Query_Keys.applied_discount),
  getBaseQueryKey(Query_Keys.classified_discount_records),
  getBaseQueryKey(Query_Keys.managed_configured_discounts_dropdown),
  checkInComplianceRefreshKeys,
  // A perq's managed status decides whether the Billing Report bills its discounts.
  billingReportRefreshKeys,
);

export const configuredDiscountMutationKeyGroups = {
  create: baseConfiguredDiscountKeys,
  update: baseConfiguredDiscountKeys,
  delete: baseConfiguredDiscountKeys,
};
